<template>
  <TopGradientBlockLayout>
    <div class="text-xl font-bold text-text leading-tight mb-8" v-html="helperObject.title"></div>
    <div class="text-text-label text-md leading-8" v-html="helperObject.text">
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import helperData from "@/components/common/Helper/helperData";

export default {
  name: "HelperProvider",
  props: {
    helperSlug: {
      type: String,
    }
  },
  components: {TopGradientBlockLayout},
  computed: {
    availableHelperObjects() {
      return Object.keys(helperData);
    },
    helperObject() {
      return this.availableHelperObjects.includes(this.helperSlug)
          ? helperData[this.helperSlug]
          : helperData['default'];
    }
  }
}
</script>